import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface ShopifyAppUpdateDialogProps {
  open: boolean;
  accountNames: string[];
  onClose: () => void;
  onUpdate: () => void;
}

export default function ShopifyAppUpdateDialog({ open, accountNames, onClose, onUpdate }: ShopifyAppUpdateDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Chargemont Shopify App</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          A newer version of the Chargemont Shopify app is available for{' '}
          <strong>{accountNames.join(', ')}</strong>. To complete the update:
          <Box component="ol" sx={{ mt: 2, mb: 0, pl: 3, listStyleType: 'decimal', '& li': { mb: 0.5 } }}>
            <li>Click <strong>Update</strong> below to open the Chargemont Shopify app page.</li>
            <li>On the Shopify app page, click <strong>Open</strong>, then follow Shopify's prompts.</li>
            <li>When the process finishes, confirm that you are back in the Chargemont Dashboard.</li>
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => {
            onUpdate();
            onClose();
          }}
        >
          Update
        </Button>
      </DialogActions>
    </Dialog>
  );
}
